var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaigns---6-months-in",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Campaigns-&-Assets-Home",
    transform: "translate(-327.000000, -206.000000)",
    fill: "#7E7E7E",
    fillRule: "nonzero",
    stroke: "#7E7E7E",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-options",
    transform: "translate(178.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-5",
    transform: "translate(137.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1818182,11 L30.2727273,11 C29.3813104,11.0021353 28.6232587,11.6407675 28.4835455,12.5073234 L17.4220909,14.8403169 C17.1556019,14.1461643 16.4811845,13.6861829 15.7272727,13.6843787 L14.8181818,13.6843787 C13.8144328,13.6853406 13.0009772,14.4860023 13,15.4739645 L13,22.6323078 C13.0009772,23.6202701 13.8144328,24.4209318 14.8181818,24.4218936 L15.7272727,24.4218936 C16.325951,24.4214526 16.8859577,24.1306652 17.2243182,23.6445423 L18.4585455,23.8614848 L18.4585455,26.2114794 C18.4585431,26.6108926 18.7274867,26.9619395 19.1176364,27.0717781 L22.2954545,27.966571 C22.56982,28.0420511 22.864234,27.9881556 23.0926818,27.8206303 C23.3205066,27.6515927 23.454493,27.387089 23.4545455,27.1062723 L23.4545455,24.7395451 L28.4863636,25.6239584 C28.6374402,26.4792843 29.3907015,27.1043361 30.2727273,27.1062723 L31.1818182,27.1062723 C32.1855672,27.1053105 32.9990228,26.3046488 33,25.3166865 L33,12.7895858 C32.9990228,11.8016235 32.1855672,11.0009619 31.1818182,11 Z M15.7272727,22.6323078 L14.8181818,22.6323078 L14.8181818,15.4739645 L15.7272727,15.4739645 L15.7272727,22.6323078 Z M17.5454545,16.6448905 L28.4545455,14.3440201 L28.4545455,23.8005942 L17.5454545,21.8831872 L17.5454545,16.6448905 Z M21.6363636,25.9196427 L20.2767273,25.5368951 L20.2767273,24.1812838 L21.6363636,24.4200146 L21.6363636,25.9196427 Z M31.1818182,25.3166865 L30.2727273,25.3166865 L30.2727273,12.7895858 L31.1818182,12.7895858 L31.1818182,25.3166865 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCampaign);
export default __webpack_public_path__ + "static/media/AllCampaign.9aa6226b.svg";
export { ForwardRef as ReactComponent };